import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, FileCheck, Infinity, ShieldCheck } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-12 px-4 bg-navy-800 relative overflow-hidden" data-id="element-26">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[150px] pointer-events-none" data-id="element-27" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-29">
          <h2 className="text-5xl md:text-7xl font-bebas text-white mb-8" data-id="element-30">
            Este mazo no va a estar acá
            <br className="hidden md:block" data-id="element-31" /> cuando termine el mundial.
          </h2>

          <div className="space-y-2 text-xl text-white/80 mb-12 font-light" data-id="element-32">
            <p data-id="element-33">
              Descargalo hoy. Imprimilo esta semana. Jugalo en cada previa, en
              cada asado, en cada festejo.
            </p>
            <p className="text-gold font-medium" data-id="element-34">
              Y cuando alguien te pregunte de dónde lo sacaste, sabés la
              respuesta.
            </p>
          </div>

          <motion.div whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block" data-id="element-35">
            <button className="group relative inline-flex items-center justify-center gap-3 px-8 md:px-12 py-5 bg-gold text-navy-900 font-bold text-xl md:text-2xl rounded-xl overflow-hidden shadow-[0_0_40px_rgba(212,175,55,0.3)] hover:shadow-[0_0_60px_rgba(212,175,55,0.5)] transition-shadow animate-[pulse_2s_ease-in-out_infinite]" data-id="element-36">
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-37" />
              <span className="relative z-10" data-id="element-38">
                QUIERO MI EDICIÓN LIMITADA — $19.900 pesos
              </span>
            </button>
          </motion.div>

          <div className="mt-8 flex flex-col items-center gap-4" data-id="element-39">
            <div className="text-white/60 text-sm mb-2" data-id="element-40">Pagá con:</div>
            <div className="flex items-center justify-center gap-5 mb-6" data-id="element-41">
              {/* VISA */}
              <div className="px-5 py-2.5 bg-[#142787] rounded-lg flex items-center justify-center" data-id="element-42">
                <span className="text-white font-bold italic text-lg tracking-wider" data-id="element-43">
                  VISA
                </span>
              </div>
              {/* Mastercard */}
              <div className="px-5 py-2.5 bg-navy-900 border border-white/10 rounded-lg flex items-center justify-center" data-id="element-44">
                <div className="w-6 h-6 rounded-full bg-[#EB001B] opacity-90 z-10 translate-x-1.5" data-id="element-45"></div>
                <div className="w-6 h-6 rounded-full bg-[#F79E1B] opacity-90 -translate-x-1.5" data-id="element-46"></div>
              </div>
              {/* Mercado Pago */}
              <div className="px-2 py-1 bg-white rounded-lg flex items-center justify-center" data-id="element-47">
                <img src="https://cdn.magicpatterns.com/uploads/iWmpLkgUmC8xuDezegJkdt/images.jpg" alt="Mercado Pago" className="h-9 w-auto object-contain" data-id="element-48" />
              </div>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-3" data-id="element-49">
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-navy-900 border border-gold/30 text-sm text-white/80" data-id="element-50">
                <Zap className="w-4 h-4 text-gold" data-id="element-51" />
                <span data-id="element-52">Descarga inmediata</span>
              </div>
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-navy-900 border border-gold/30 text-sm text-white/80" data-id="element-53">
                <FileCheck className="w-4 h-4 text-gold" data-id="element-54" />
                <span data-id="element-55">Archivo digital de alta resolución</span>
              </div>
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-navy-900 border border-gold/30 text-sm text-white/80" data-id="element-56">
                <Infinity className="w-4 h-4 text-gold" data-id="element-57" />
                <span data-id="element-58">Acceso de por vida</span>
              </div>
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-navy-900 border border-gold/30 text-sm text-white/80" data-id="element-59">
                <ShieldCheck className="w-4 h-4 text-gold" data-id="element-60" />
                <span data-id="element-61">Único pago, sin mensualidades</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}